import api from './api';

/**
 * Validate password for electronic sign.
 * POSTs to api/Auth/ValidatePassword with session cookie (JSON body).
 * @param {string} password - Plain password
 * @returns {Promise<{ isSuccess: boolean, strMessage?: string }>}
 */
export async function validatePassword(password) {
  const { data } = await api.post('/Auth/ValidatePassword', { Password: password });
  return {
    isSuccess: data?.isSuccess === true,
    strMessage: data?.StrMessage ?? data?.strMessage ?? '',
  };
}
